const ActionButton = ({
  onClick,
  variant = "primary",
  icon,
  children,
  ...props
}) => {
  const getButtonClass = () => {
    switch (variant) {
      case "success":
        return "btn-primary btn-success";
      case "error":
        return "btn-primary btn-error";
      case "info":
        return "btn-primary btn-info";
      case "neutral":
        return "btn-primary btn-neutral";
      default:
        return "btn-primary btn-info";
    }
  };

  return (
    <button onClick={onClick} className={getButtonClass()} {...props}>
      {icon}
      <span>{children}</span>
    </button>
  );
};

export default ActionButton;
